"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Card } from "@/components/ui/card";
export default function Testimonials() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const testimonials = [{
    quote: "Bringing home our little Elf Sphynx from Catsy Cats was a dream. The care and love they put into raising these kittens is evident in every purr.",
    author: "Sarah M.",
    role: "Proud Cat PAWrent",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709223/img/client_sarah_portrait.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709223/img/client_sarah_portrait.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709223/img/client_sarah_portrait.webp-wvc-sizes",
    rotation: "-rotate-[0.5deg]",
    hoverRotation: "hover:-rotate-[1.5deg]"
  }, {
    quote: "The quality of their breeding program is unmatched. Our Persian kitten is healthy, social, and has the most beautiful personality. Truly luxury service.",
    author: "David L.",
    role: "Exotic Cat Enthusiast",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709223/img/client_david_portrait.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709223/img/client_david_portrait.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709223/img/client_david_portrait.png-wvc-sizes",
    rotation: "rotate-0",
    hoverRotation: "hover:rotate-[1deg]"
  }, {
    quote: "Catsy Cats made the entire process seamless. From the first inquiry to the day our kitten arrived, we felt supported and informed every step of the way.",
    author: "Elena R.",
    role: "Happy Family",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709223/img/client_elena_portrait.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709223/img/client_elena_portrait.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709223/img/client_elena_portrait.webp-wvc-sizes",
    rotation: "rotate-[0.5deg]",
    hoverRotation: "hover:rotate-[1.5deg]"
  }];
  return <section data-section-id="15992" id="family-testimonials" className="bg-background text-foreground py-24 md:py-32 px-6">
      <div className="max-w-[1280px] mx-auto">
        {}
        <div ref={headingRef} className={`max-w-[640px] mx-auto text-center mb-16 md:mb-20 transition-all duration-[560ms] ease-out ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h2 className="font-default font-serif font-normal text-foreground leading-[1.08] tracking-tight" style={{
          fontSize: "clamp(2rem, 4.2vw, 3.5rem)"
        }}>
            <span>Words from our </span>
            <span className="relative inline-block italic">
              <span className="relative z-10">families</span>
              <svg className="absolute -inset-x-3 -inset-y-2 w-[calc(100%+1.5rem)] h-[calc(100%+1rem)] pointer-events-none" viewBox="0 0 200 100" fill="none" preserveAspectRatio="none" aria-hidden="true">
                <path d="M 30 50 C 30 20, 80 12, 110 14 C 150 16, 180 28, 182 52 C 184 76, 150 88, 105 86 C 60 84, 28 78, 26 54 C 25 42, 32 32, 50 26" stroke="var(--primary)" strokeWidth="2.5" strokeLinecap="round" fill="none" strokeDasharray="600" strokeDashoffset={headingVisible ? "0" : "600"} style={{
                transition: "stroke-dashoffset 700ms ease-out",
                transitionDelay: "300ms"
              }} />
              </svg>
            </span>
          </h2>
          <p className="mt-6 font-default text-muted-foreground leading-[1.6]" style={{
          fontSize: "clamp(0.9375rem, 0.9vw, 1rem)"
        }}>
            Discover the joy and PAWpanionship our rare kittens bring to homes across the nation.
          </p>
        </div>

        {}
        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-3 gap-7">
          {testimonials.map((t, i) => <div data-index={i} key={i} className={`transition-all duration-[560ms] ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: `${i * 80}ms`
        }}>
              <Card className={`group relative bg-card border border-border rounded-lg p-7 gap-0 transform ${t.rotation} ${t.hoverRotation} transition-all duration-[280ms] ease-out shadow-md`}>
                {}
                <svg className="w-8 h-8 mb-5" viewBox="0 0 40 40" fill="none" aria-hidden="true">
                  <path d="M 6 22 C 6 14, 10 8, 16 6 M 8 22 C 8 26, 10 30, 14 30 C 18 30, 20 27, 20 23 C 20 19, 17 16, 13 16 C 11 16, 9 17, 8 18" stroke="var(--primary)" strokeWidth="2.2" strokeLinecap="round" fill="none" />
                  <path d="M 22 22 C 22 14, 26 8, 32 6 M 24 22 C 24 26, 26 30, 30 30 C 34 30, 36 27, 36 23 C 36 19, 33 16, 29 16 C 27 16, 25 17, 24 18" stroke="var(--primary)" strokeWidth="2.2" strokeLinecap="round" fill="none" />
                </svg>

                {}
                <p className="font-default font-normal text-foreground leading-[1.65]" style={{
              fontSize: "clamp(1.0625rem, 1.1vw, 1.1875rem)"
            }}>
                  {t.quote}
                </p>

                {}
                <svg className="mt-7 mb-6" width="40" height="8" viewBox="0 0 40 8" fill="none" aria-hidden="true">
                  <path d="M 1 4 C 6 1, 12 7, 20 4 C 28 1, 34 7, 39 4" stroke="var(--primary)" strokeWidth="1.5" strokeLinecap="round" fill="none" />
                </svg>

                {}
                <div className="flex items-center gap-3">
                  <SafeHydrate><Avatar className="size-10 rounded-lg overflow-hidden">
                    <AvatarImage src={t.avatar} alt={t.author} />
                    <AvatarFallback className="bg-secondary text-secondary-foreground font-default text-sm">
                      {t.author.charAt(0)}
                    </AvatarFallback>
                  </Avatar></SafeHydrate>
                  <div className="flex flex-col">
                    <span className="font-default font-serif font-medium text-foreground text-base leading-tight">
                      {t.author}
                    </span>
                    <span className="font-default text-muted-foreground mt-0.5" style={{
                  fontSize: "0.8125rem",
                  letterSpacing: "0.04em"
                }}>
                      {t.role}
                    </span>
                  </div>
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}